import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  background?: string;
  color?: string;
};

const AvatarTen: FC<Props> = ({
  background = colors['--slate'],
  color = colors['--body'],
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ background, borderRadius: '9px' }}
  >
    <path
      d="M22.4999 16.8744C22.4999 16.3873 22.9145 15.9925 23.4258 15.9925H24.074C24.5854 15.9925 25 15.5976 25 15.1106L25 10.8593C25 10.3723 24.5854 9.97746 24.074 9.97746H23.3333C22.8219 9.97746 22.4073 10.3723 22.4073 10.8593L22.4073 15.1106C22.4073 15.5976 21.9927 15.9925 21.4813 15.9925H11.4893V18.4618H21.5739C22.0853 18.4618 22.4999 18.0669 22.4999 17.5799V16.8744Z"
      fill={color}
    />
    <path
      d="M19.2923 15.9925V18.4618L10.4261 18.4618C9.91466 18.4618 9.50012 18.0669 9.50012 17.5799V16.8744C9.50012 16.3873 9.08554 15.9925 8.57415 15.9925H7.92597C7.41457 15.9925 7 15.5976 7 15.1106L7.00001 10.8593C7.00001 10.3723 7.41458 9.97746 7.92598 9.97746H8.66675C9.17814 9.97746 9.5927 10.3723 9.5927 10.8593L9.5927 15.1106C9.5927 15.5976 10.0073 15.9925 10.5187 15.9925L19.2923 15.9925Z"
      fill={color}
    />
    <path
      d="M22.4999 7.60937C22.4999 8.09642 22.9145 8.49125 23.4259 8.49125H24.074C24.5854 8.49125 25 8.88609 25 9.37314L25 13.6244C25 14.1114 24.5854 14.5063 24.074 14.5063H23.3333C22.8219 14.5063 22.4073 14.1114 22.4073 13.6244L22.4073 9.37314C22.4073 8.88609 21.9927 8.49125 21.4813 8.49125L11.4893 8.49126V6.02197L21.5739 6.02197C22.0853 6.02197 22.4999 6.4168 22.4999 6.90386V7.60937Z"
      fill={color}
    />
    <path
      d="M19.2923 8.49125V6.02197L10.4261 6.02197C9.91467 6.02197 9.50012 6.4168 9.50012 6.90386V7.60937C9.50012 8.09642 9.08555 8.49126 8.57415 8.49126L7.92598 8.49126C7.41458 8.49126 7.00001 8.88609 7.00001 9.37314L7 13.6244C7 14.1114 7.41457 14.5063 7.92597 14.5063H8.66674C9.17814 14.5063 9.5927 14.1114 9.5927 13.6244L9.5927 9.37314C9.5927 8.88609 10.0073 8.49126 10.5187 8.49126L19.2923 8.49125Z"
      fill={color}
    />
    <path
      d="M16 17.6357V20.105H16.8213C17.3327 20.105 17.7472 20.4998 17.7472 20.9869V25.1401C17.7472 25.6271 18.1618 26.022 18.6732 26.022H19.414C19.9253 26.022 20.3399 25.6271 20.3399 25.1401V20.9869C20.3399 20.4998 19.9253 20.105 19.414 20.105H18.7658C18.2544 20.105 17.8398 19.7102 17.8398 19.2231V18.5176C17.8398 18.0306 17.4253 17.6357 16.9139 17.6357H16Z"
      fill={color}
    />
    <path
      d="M16 17.6357V20.105H15.1787C14.6674 20.105 14.2528 20.4998 14.2528 20.9869L14.2528 25.1401C14.2528 25.6271 13.8382 26.022 13.3268 26.022H12.5861C12.0747 26.022 11.6601 25.6271 11.6601 25.1401V20.9869C11.6601 20.4998 12.0747 20.105 12.5861 20.105H13.2342C13.7456 20.105 14.1602 19.7102 14.1602 19.2231V18.5176C14.1602 18.0306 14.5747 17.6357 15.0861 17.6357H16Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2497 12.477C12.2497 12.9641 12.6643 13.3589 13.1757 13.3589H13.9165C14.4279 13.3589 14.8425 12.9641 14.8425 12.477V11.7274C14.8425 11.2404 14.4279 10.8456 13.9165 10.8456L13.1757 10.8456C12.6643 10.8456 12.2497 11.2404 12.2497 11.7274V12.477Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.877 12.477C16.877 12.9641 17.2915 13.3589 17.8029 13.3589H18.5437C19.0551 13.3589 19.4697 12.9641 19.4697 12.477V11.7274C19.4697 11.2404 19.0551 10.8456 18.5437 10.8456L17.8029 10.8456C17.2915 10.8456 16.877 11.2404 16.877 11.7274V12.477Z"
      fill={color}
    />
  </svg>
);

export default AvatarTen;
